import type { ReactNode } from 'react'

/**
 * Cabeçalho de página.
 *
 * O título fica dentro da coluna de conteúdo, não numa barra global: o menu
 * lateral já diz onde se está, e uma segunda barra fixa comeria altura útil de
 * uma tela que é toda tabela. O que fica à direita é ação — criar, filtrar — e
 * nunca navegação.
 */
export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string
  description?: ReactNode
  actions?: ReactNode
}) {
  return (
    <header className="flex shrink-0 flex-wrap items-center gap-x-4 gap-y-1 border-b border-line bg-canvas px-3 py-1.5">
      <div className="min-w-0">
        <h1 className="text-base font-medium text-fg">{title}</h1>
        {description != null && <p className="truncate text-micro text-fg-muted">{description}</p>}
      </div>
      {actions !== undefined && (
        <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div>
      )}
    </header>
  )
}

/** Barra de filtros de uma listagem — acima da tabela, dentro da página. */
export function Toolbar({ children }: { children: ReactNode }) {
  return (
    <div className="flex shrink-0 flex-wrap items-center gap-2 border-b border-line-subtle px-3 py-1.5">
      {children}
    </div>
  )
}
